import { render, staticRenderFns } from "./SiteAppsForgeAppConfiguration.vue?vue&type=template&id=c30b251a&scoped=true&"
import script from "./SiteAppsForgeAppConfiguration.vue?vue&type=script&lang=js&"
export * from "./SiteAppsForgeAppConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./SiteAppsForgeAppConfiguration.vue?vue&type=style&index=0&id=c30b251a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c30b251a",
  null
  
)

export default component.exports